module.exports = __webpack_public_path__ + "img/ai_writingM.bfce3494.png";